/**
 * 本地存储缓存
 * 存取时自动 parse 和 stringify JSON
 */
export class JsonStorageCache {
    private storage: Storage;
    constructor(storage: Storage) {
        this.storage = storage;
    }

    set(key: string, value: any) {
        this.storage.setItem(key, JSON.stringify(value));
    }

    get(key: string) {
        const value = this.storage.getItem(key);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            console.error(`Failed to parse JSON from storage for key: ${key}`, e);
            return null;
        }

    }

    remove(key: string) {
        this.storage.removeItem(key);
    }
}
